import { render, staticRenderFns } from "./ServiceDescription.vue?vue&type=template&id=4fb493b7&scoped=true&"
import script from "./ServiceDescription.vue?vue&type=script&lang=js&"
export * from "./ServiceDescription.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDescription.vue?vue&type=style&index=0&id=4fb493b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb493b7",
  null
  
)

export default component.exports